import { Route, Routes, redirect } from "react-router-dom"
import { useKeycloak } from "@react-keycloak/web"
import LinearProgress from "@mui/material/LinearProgress"
import Hiring from "./hiring/Index"
import Container from "@mui/material/Container"

export const Routing = () => {
  const { keycloak } = useKeycloak()
  if (keycloak.authenticated === false) {
    return <>{redirect(keycloak.createLoginUrl())}</>
  }
  return keycloak.authenticated ? (
    <Container disableGutters maxWidth="lg">
      <Routes>
        <Route path="*" element={<Hiring />} />
      </Routes>
    </Container>
  ) : (
    <Routes>
      <Route path="*" element={<LinearProgress />} />
    </Routes>
  )
}
